export const REPORT_OPTIONS = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalseparator: '.',
  showLabels: true,
  showTitle: true,
  useBom: true,
  noDownload: false,
  headers: ["Name", "Age"]
};

export const ACCOUNT_OPTIONS = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalseparator: '.',
  showLabels: true,
  showTitle: true,
  useBom: true,
  noDownload: false,
  headers: ["Name", "Age"]
};

export const MOCK_DATA = [
  {
    name: "Test 1",
    age: 13,
  },
  {
    name: 'Test 2',
    age: 11,
  }
];
